(() => {
  const formId = 'SyDQRx';
  let requested = false;
  let opener = null;
  let openTimeout;
  let automaticallyDismissed = false;
  let dismissFrame = 0;
  let activeClose = null;
  const modalSelector = '.klaviyo-form-SyDQRx, [data-testid="klaviyo-form-SyDQRx"], [role="dialog"][aria-label="POPUP Form"]';
  const setRequested = value => {
    requested = value;
    document.documentElement.classList.toggle('gb-promo-requested', value);
  };
  const cancelRequest = () => {
    clearTimeout(openTimeout);
    setRequested(false);
    opener = null;
    const status = document.querySelector('[data-gb-promo-status]');
    if (status) status.textContent = '';
  };
  const dismissUnrequested = () => {
    const nextClose = Array.from(document.querySelectorAll(modalSelector), form => {
      const dialog = form.closest('[role="dialog"]') || form.parentElement;
      return dialog?.querySelector('.klaviyo-close-form, button[aria-label="Close dialog"], button[aria-label="Close form"], button[aria-label="Cerrar promoción"]');
    }).find(close => close && !close.closest('[inert]')) || null;
    if (nextClose !== activeClose) {
      if (activeClose && !nextClose && requested) {
        clearTimeout(openTimeout);
        setRequested(false);
        if (opener?.isConnected) opener.focus({ preventScroll: true });
        opener = null;
      }
      activeClose = nextClose;
      automaticallyDismissed = false;
    }
    // A delayed marketing response must not take over search or a cart interaction.
    if (requested && document.querySelector('details-modal details[open], cart-drawer.active, cart-notification.active')) cancelRequest();
    document.querySelectorAll('.kl-teaser-SyDQRx [role="button"]').forEach(button => {
      if (/15\s*%|Get.*Off/i.test(button.textContent)) button.textContent = '10 % de bienvenida';
    });
    if (requested) {
      if (activeClose) {
        clearTimeout(openTimeout);
        const status = document.querySelector('[data-gb-promo-status]');
        if (status?.textContent) status.textContent = '';
      }
      document.querySelectorAll(modalSelector).forEach(form => {
        const close = form.querySelector('button[aria-label="Close dialog"]');
        if (close) close.setAttribute('aria-label', 'Cerrar promoción');
        const email = form.querySelector('input[type="email"]');
        if (email) { email.setAttribute('placeholder', 'Correo electrónico'); email.setAttribute('aria-label', 'Correo electrónico'); }
      });
      return;
    }
    if (!activeClose || automaticallyDismissed || dismissFrame) return;
    dismissFrame = requestAnimationFrame(() => {
      dismissFrame = 0;
      if (requested || automaticallyDismissed || !activeClose || activeClose.closest('[inert]')) return;
      const close = activeClose;
      automaticallyDismissed = true;
      close.setAttribute('data-gb-automatic-dismiss', '');
      try {
        close.click();
      } finally {
        close.removeAttribute('data-gb-automatic-dismiss');
      }
    });
  };
  const observer = new MutationObserver(dismissUnrequested);
  observer.observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['inert']});
  document.addEventListener('submit', event => {
    if (!requested || !event.target.matches('form[data-type="add-to-cart-form"], form[action$="/cart/add"], form[action$="/cart"]')) return;
    cancelRequest();
    dismissUnrequested();
  }, true);
  document.querySelectorAll('[data-gb-promo]').forEach(button => button.addEventListener('click', () => {
    opener = button;
    setRequested(true);
    const status = document.querySelector('[data-gb-promo-status]');
    if (status) status.textContent = 'Abriendo la bienvenida. Si no aparece, revisa tus preferencias de cookies.';
    clearTimeout(openTimeout);
    openTimeout = setTimeout(() => {
      setRequested(false);
      dismissUnrequested();
      opener = null;
      if (status) status.textContent = 'La promoción no se ha podido abrir. Puedes revisar tus preferencias de cookies e intentarlo de nuevo.';
    }, 10000);
    // Queue last: a loaded Klaviyo client may dispatch its open event synchronously.
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);
  }));
  window.addEventListener('klaviyoForms', event => {
    if (event.detail?.formId !== formId) return;
    if (event.detail.type === 'open') {
      automaticallyDismissed = false;
      clearTimeout(openTimeout);
      const status = document.querySelector('[data-gb-promo-status]');
      if (status) status.textContent = '';
      dismissUnrequested();
    }
    if (['close', 'submit'].includes(event.detail.type)) {
      if (event.detail.type === 'close') {
        automaticallyDismissed = true;
        clearTimeout(openTimeout);
        setRequested(false);
        if (opener?.isConnected) opener.focus({ preventScroll: true });
        opener = null;
      }
    }
  });
  dismissUnrequested();
})();
